import { RouteObject } from "react-router-dom";
import { withHandle } from "../../utils/route.util";
import { path as createPath, CustomerProductCreateView } from "./CustomerProductCreateView";
import { CustomerProductFilterInner, path as filterPath } from "./CustomerProductFilter";
import { newProductCreate } from "./CustomerProductsView";
import { CustomerProductView, CustomerProductViewV2 } from "./CustomerProductView";
import { ProductCreateNavigator } from "./ProductCreateNavigator";

export const productCreateRoute: RouteObject = newProductCreate
  ? {
      path: createPath,
      element: <ProductCreateNavigator />,
      ...withHandle("customer-product-create"),
    }
  : {
      path: createPath,
      element: <CustomerProductCreateView />,
      ...withHandle("customer-product-create"),
    };

export const productDetailsRoute: RouteObject = newProductCreate
  ? {
      path: ":id",
      element: <CustomerProductViewV2 />,
      ...withHandle("customer-product-detail"),
    }
  : {
      path: ":id",
      element: <CustomerProductView />,
      ...withHandle("customer-product-detail"),
    };

export const productFiltersRoute: RouteObject | undefined = newProductCreate
  ? {
      path: filterPath,
      element: <CustomerProductFilterInner />,
    }
  : undefined;
